/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const d = (r, e) => {
  if (e.type)
    switch (e.type) {
      case "add":
        return [...r, e.payload];
      case "remove":
        return r.filter((s) => s !== e.payload);
      default:
        return r;
    }
  else
    return [];
};
export {
  d as observersReducer
};
